import React from "react";

import sortingContainer from "../../../../public/environment-label-icons/sorting-container.png";

const IconSortingContainer = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <image href={sortingContainer.src} width={"100%"} height={"100%"} />
  </svg>
);
export default IconSortingContainer;
